/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { retailAction } from '@msdyn365-commerce/retail-proxy';
import { IProductPromotion } from './DataServiceEntities.g';
import { getProductPromotionsInput } from './DataActionExtension.g';

/**
 * GetProductPromotions Input Action
 */
export class GetProductPromotionsInput implements Msdyn365.IActionInput {
    public readonly recordId: number;
    public readonly distinctProductVariantId: number;

    constructor(recordId: number, distinctProductVariantId: number) {
        this.recordId = recordId;
        this.distinctProductVariantId = distinctProductVariantId;
    }

    public getCacheKey = () => `${this.recordId}`;
    public getCacheObjectType = () => 'HEI-ProductPromotions';
    //public dataCacheType = (): Msdyn365.CacheType => 'application';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (context: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(context);
    if (productId) {
        return new GetProductPromotionsInput(+productId, +productId);
    } else {
        throw new Error('Unable to create GetProductInfoInput, no productId found on module config or query');
    }
};

async function action(input: GetProductPromotionsInput, ctx: Msdyn365.IActionContext): Promise<IProductPromotion[]> {
    var productPromotionsInput = getProductPromotionsInput({ Paging: { Top: 5 } }, input.recordId, input.distinctProductVariantId);
    return retailAction(productPromotionsInput, ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProductPromotion[]>>action,
    id: 'hei-get-product-promotions',
    input: createInput
    // isBatched: true
});
